import React from 'react';
import { FaFilter, FaTimes } from 'react-icons/fa';
import './FilterBar.css';

const FilterBar = ({ filters, onFilterChange, onClearFilters }) => {
  const activeFilterCount = Object.values(filters).filter(v => v && v !== 'all').length;

  return (
    <div className="filter-bar">
      <div className="filter-header">
        <FaFilter className="filter-icon" />
        <span className="filter-label">Filters</span>
        {activeFilterCount > 0 && (
          <span className="filter-badge">{activeFilterCount}</span>
        )}
      </div>

      <div className="filter-controls">
        <select
          className="filter-select"
          value={filters.status || 'all'}
          onChange={(e) => onFilterChange('status', e.target.value)}
        >
          <option value="all">All Status</option>
          <option value="available">Available</option>
          <option value="sold">Sold</option>
          <option value="reserved">Reserved</option>
        </select>

        <select
          className="filter-select"
          value={filters.featured || 'all'}
          onChange={(e) => onFilterChange('featured', e.target.value)}
        >
          <option value="all">All Featured</option>
          <option value="yes">Featured Only</option>
          <option value="no">Not Featured</option>
        </select>

        <select
          className="filter-select"
          value={filters.year || 'all'}
          onChange={(e) => onFilterChange('year', e.target.value)}
        >
          <option value="all">All Years</option>
          <option value="2024">2024</option>
          <option value="2023">2023</option>
          <option value="2022">2022</option>
          <option value="2021">2021</option>
          <option value="2020">2020</option>
          <option value="2019">2019 & Older</option>
        </select>

        {activeFilterCount > 0 && (
          <button className="filter-clear-btn" onClick={onClearFilters}>
            <FaTimes /> Clear Filters
          </button>
        )}
      </div>
    </div>
  );
};

export default FilterBar;
